export const getEntitiyTitle = (entityType: number | string) => {
  switch (Number(entityType)) {
    case 1:
      return "Creditor";
    case 2:
      return "Claim";
    case 3:
      return "Claim Item";
    case 4:
      return "Creditor Votes";
    case 5:
      return "Manual Data Source";
    case 6:
      return "Payment";
    case 7:
      return "Stage Document Attachment";
    case 8:
      return "Payee Match";
    case 9:
      return "Bank Activities";
    case 11:
      return "Supporting Document Attachment";
    default:
      return "-";
  }
};
